


import React from "react";

const ContactBox = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Contact Us</h1>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <section className="contact-section-custom">
        <div className="container">
          <div className="row g-4">

            {/* Contact */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-card-custom">
                <div className="contact-icon-custom">
                  <i className="fas fa-phone-alt"></i>
                </div>

                <h3>Contact Us</h3>

                <a href="tel:+919545731161">
                  +91 9545731161
                </a>

               
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-card-custom">
                <div className="contact-icon-custom">
                  <i className="fas fa-envelope"></i>
                </div>

                <h3>Email Us</h3>

                <a href="mailto:booking@mumbaiairportcabs.com">
                  booking@mumbaiairportcabs.com
                </a>

             
              </div>
            </div>

            {/* Address */}
            <div className="col-lg-4 col-md-6">
              <div className="contact-card-custom">
                <div className="contact-icon-custom">
                  <i className="fas fa-map-marker-alt"></i>
                </div>

                <h3>Our Address</h3>

                <p>
                  Mumbai Airport Cab Services
                  <br />
                 SAWANT SADAN 05 Ramachandra cold drinks House, Near SBI Bank Nehru  Road Opp Noble Medical, 
           
                  Vile Parle East Mumbai - 400057
                  <br />
                  
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ContactBox;